import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommerceService } from 'app/services/commerce.service';
import { CreateCommerceDto } from '../add-availed-product-dialog/add-availed-product';
import { MessageService } from 'primeng/api';
import * as moment from 'moment';

@Component({
  selector: 'add-availed-product-dialog',
  standalone: false,
  templateUrl: './add-availed-product-dialog.component.html',
  styleUrl: './add-availed-product-dialog.component.scss'
})
export class AddAvailedProductDialogComponent implements OnInit {
  @Input() driver: any;
  @Input() visible: boolean = false;
  @Output() hideAddProduct = new EventEmitter<boolean>();
  @Output() saveAddedProduct = new EventEmitter<any>();

  constructor(
    private commerceService: CommerceService,
    private messageService: MessageService
  ){}

  public menuItems: any[] = [
    {label: 'Product Details'},
    {label: 'Payment Terms'},
    {label: 'Confirmation'}
  ];
  public warningMessage: any[] = [
    `<span class="font-semibold">Note</span>
     Please ensure you've explained the product details and payment terms to the driver — especially any penalties and<br>
     collection rules — before proceeding with this assignment.`,
     `<span class="font-semibold">Admin Reminder</span>
     Please make sure to explain the payment schedule, deduction amount, total number of payments, and any penalties clearly to the driver<br>
     before proceeding. The driver must fully understand the terms before signing the documents.`
  ];
  public activeIndex: number = 0;
  public isFormNotValid: boolean[] = [true, true];
  public loading: boolean = false;

  ngOnInit(): void {
  }

  public getServiceTypeIcon(service: string): string {
    const tmp = service.split(' ');
    if (tmp && tmp.length === 3) {
        return tmp[2].toLowerCase();
    }
    return '';
  }

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  hideDialog(){
    this.visible = false;
    this.hideAddProduct.emit(this.visible);
    this.commerceService.resetAddProductModels();
  }

  nextStep(){
    this.activeIndex = this.activeIndex + 1;
  }

  previousStep(){
    this.activeIndex = this.activeIndex - 1;
  }

  isFormValid(event: boolean){
    this.isFormNotValid[this.activeIndex] = event;
  }

  saveProduct(){
    this.loading = true;
    const productDetails = this.commerceService.productDetailModel;
    const paymentTerms = this.commerceService.paymentTermsModel;

    const formData = new FormData();
    productDetails.files.forEach((file: any) => {
      formData.append('FormFiles', file); // backend must expect 'images' as an array
    });
    paymentTerms.files.forEach((file: any) => {
      formData.append('FormFiles', file); // backend must expect 'images' as an array
    });

    const dto: CreateCommerceDto = {
      RiderId: this.driver.XpressRiderId,
      ProductId: productDetails.selectedProduct.Id,
      ProductPrice: productDetails.selectedProduct.Price,
      UniqueIdentifier: productDetails.serialNumber,
      PaymentType: productDetails.payment,
      SecurityBondPercent: productDetails.selectedProduct.SecurityBondPercent,
      SecurityBondAmount: productDetails.selectedProduct.SecurityBondAmount,
      TimeZoneOffset: 8,
      RepaymentPenalty: {
        PenaltyCutOff: productDetails.selectedProduct.PenaltyCutOffDays,
        PenaltyDaysBeforeCollection: productDetails.selectedProduct.DaysBeforeCollection
      },
      PaymentTerms: {
        DeductionFrequency: paymentTerms.selectedFrequency.value,
        PaymentPeriod: paymentTerms.selectedPeriod.value,
        IsDriverConsent: paymentTerms.driverConsent
      }
    };
    formData.append('RiderId', dto.RiderId);
    formData.append('ProductId', dto.ProductId);
    formData.append('ProductPrice', dto.ProductPrice.toString());
    formData.append('UniqueIdentifier', dto.UniqueIdentifier ? dto.UniqueIdentifier : '');
    formData.append('DateStarted', moment(new Date()).format('YYYY-MM-DD'));
    formData.append('DateReleased', '');
    formData.append('PaymentType', dto.PaymentType.toString());
    formData.append('SecurityBondPercent', dto.SecurityBondPercent.toString());
    formData.append('SecurityBondAmount', dto.SecurityBondAmount.toString());
    formData.append('TimeZoneOffset', dto.TimeZoneOffset.toString());
    formData.append('RepaymentPenalty.PenaltyCutOff', dto.RepaymentPenalty.PenaltyCutOff.toString());
    formData.append('RepaymentPenalty.PenaltyDaysBeforeCollection', dto.RepaymentPenalty.PenaltyDaysBeforeCollection.toString());
    formData.append('RepaymentPenalty.PenaltyAmount', '500');
    formData.append('Status', '3');
    formData.append('PaymentTerms.DeductionFrequency', dto.PaymentTerms.DeductionFrequency.toString());
    formData.append('PaymentTerms.PaymentPeriod', dto.PaymentTerms.PaymentPeriod.toString());
    formData.append('PaymentTerms.IsDriverConsent', dto.PaymentTerms.IsDriverConsent.toString());

    this.commerceService.createCommerce(formData, this.messageService)
      .then(data => {
          if (!data) {
            this.loading = false;
            return;
          }

          if (!data.Success) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
              this.loading = false;
              return;
          }
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully created a product' });
          this.loading = false;
          this.visible = false;
          this.saveAddedProduct.emit(this.visible);
      })
      .catch(error => {
        this.loading = false;
        throw error;
      });
  }
}
